export default {
    // CO00118910, jihwan_choi1, Mac(PC) 사용자 대상 앱 다운로드 제한
    // 규칙 1. 플랫폼은 항상 IOS/AOS로 나뉜다. (선 구분)
    // 규칙 2. IOS 안에 isMac/isIOSNotMac 으로 나뉜다.
    // 기본 IOS
    isIOS() {
        const userAgent = navigator.userAgent.toLowerCase();;

        return userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1
            || userAgent.indexOf("ipod") > -1 || userAgent.indexOf("mac os x") > -1
    },
    // 2. Mac 판별 (진짜 맥북/데스크탑)
    isIOSMac() {
        const ua = navigator.userAgent.toLowerCase();

        // 1. 기본적으로 Mac OS 키워드가 포함되어야 함
        const isMacUA = /macintosh|mac os x/.test(ua);

        // 2. 터치 포인트가 없어야 함 (iPadOS 방어)
        // 3. 'Safari'는 괜찮지만, 모바일 크롬 등에서 간혹 생기는 이슈 방어
        const isNotMobile = !/iphone|ipod|android/.test(ua);

        // 터치 포인트가 1개 이하인 '데스크탑 Mac' 환경만 true
        return isMacUA && isNotMobile && (navigator.maxTouchPoints || 0) <= 1;
    },

    // 1. iOS 판별 (iPhone, iPad 공통, Mac제외)
    isIOSNotMac() {
        const ua = navigator.userAgent.toLowerCase();

        // 아이폰/아이팟은 UA에 이름이 명시됨
        const isIPhone = /iphone|ipod/.test(ua);

        // 최신 아이패드는 자신을 'macintosh'라고 속임.
        // 하지만 '터치 포인트'가 1개보다 많으면(멀티터치) 무조건 패드임.
        const isIPad = (ua.indexOf("ipad") > -1) ||
            (ua.indexOf("macintosh") > -1 && (navigator.maxTouchPoints || 0) > 1);

        return isIPhone || isIPad;
    },

    // 3. Android 판별 (질문자님 의도: 애플이 아니면 모두 APK 대상)
    isAndroid() {
        // 위에서 정의한 iOS도 아니면 Android(또는 윈도우 등)로 간주
        return !this.isIOS()
    }
}



// WEBPACK FOOTER //
// ./src/util/Util.js